import { LeftPanel } from "../models/global.model";
import * as GlobalActions from "./../actions/global.actions";

const initialState: LeftPanel = {
  data: {},
  currentKey: "",
  pageName: "",
  display: true,
  isCollapsed: true,
  disabled: false,
  selectedWatchlist: { watchlistId: null, label: null }, //null indicate loading state
  enableUsersnap: true,
  enablePendo: true,
};

export function globalReducer(
  state: LeftPanel = initialState,
  action: GlobalActions.Actions,
) {
  switch (action.type) {
    case GlobalActions.SET_INIDIVIDUAL_FLAG:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case GlobalActions.SET_LEFT_PANEL_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.key]: action.payload.respData,
        },
        currentKey: action.payload.key,
        display: action.payload.display,
        // isCollapsed: action.payload.isCollapsed
      };
    case GlobalActions.SET_DISPLAY:
      return {
        ...state,
        display: action.payload,
      };
    case GlobalActions.SET_COLLAPSED:
      return {
        ...state,
        isCollapsed: action.payload,
      };
    case GlobalActions.SET_DISABLED:
      return {
        ...state,
        disabled: action.payload,
      };
    case GlobalActions.ADD_WATCHLIST_DATA:
      if (state.data.watchlist) {
        state.data[action.payload.key].data["1"].values = [
          action.payload.respData,
          ...state.data[action.payload.key].data["1"].values,
        ];
        return {
          ...state,
          data: {},
        };
      }
      return state;

    case GlobalActions.DELETE_WATCHLIST_DATA:
      state.data[action.payload.key].data["1"].values = state.data[
        action.payload.key
      ].data["1"].values.filter(
        (delId) => action.payload.ids.indexOf(delId.watchlistId) === -1,
      );

      state.data[action.payload.key].data["2"].values = state.data[
        action.payload.key
      ].data["2"].values.filter(
        (delId) => action.payload.ids.indexOf(delId.watchlistId) === -1,
      );

      return {
        ...state,
        data: {},
      };
    case GlobalActions.SET_SELECTED_WATCHLIST:
      state.selectedWatchlist = { ...action.payload };
      return {
        ...state,
      };

    case GlobalActions.UPDATE_WATCHLIST_DATA:
      state.data[action.payload.key].data["1"].values = state.data[
        action.payload.key
      ].data["1"].values.map((wlItem) => {
        if (wlItem.watchlistId === action.payload.watchlistId) {
          return { ...wlItem, label: action.payload.label };
        }
        return wlItem;
      });

      return {
        ...state,
      };

    case GlobalActions.UPDATE_CHARTS_DATA:
      if (action.payload === null) {
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      if (action.payload.operation === "update") {
        state.data["charts"].data["1"].values = state.data["charts"].data[
          "1"
        ].values.map((item) => {
          if (`${item.chart_id}` === action.payload.chartId) {
            return { ...item, label: action.payload.label };
          }
          return item;
        });

        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      if (action.payload.operation === "add") {
        state.data["charts"] &&
          state.data["charts"].data["1"].values.push({
            chart_id: action.payload.chartId,
            label: action.payload.label,
            chartTypeId: action.payload.chartTypeId,
          });
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      if (action.payload.operation === "delete") {
        state.data["charts"].data["1"].values = state.data["charts"].data[
          "1"
        ].values.filter((v) => {
          return v.chart_id.toString() !== action.payload.chartId;
        });
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      return state;

    case GlobalActions.UPDATE_COMPS_DATA:
      if (action.payload === null) {
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      if (action.payload.operation === "update") {
        state.data["comptables"].data["0"].values = state.data[
          "comptables"
        ].data["0"].values.map((item) => {
          if (`${item.tab_id}` === action.payload.compId) {
            return { ...item, label: action.payload.label };
          }
          return item;
        });

        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      if (action.payload.operation === "add") {
        state.data["comptables"] &&
          state.data["comptables"].data["0"].values.push({
            tab_id: action.payload.tabId,
            label: action.payload.label,
            compType: action.payload.compType,
            shortName: action.payload.shortName,
          });
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      if (action.payload.operation === "delete") {
        state.data["comptables"].data["0"].values = state.data[
          "comptables"
        ].data["0"].values.filter((v) => {
          return v.tab_id.toString() !== action.payload.tabId;
        });
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }
      return state;

    case GlobalActions.UPDATE_COMPARATIVE_ANALYSIS_DATA:
      if (action.payload === null) {
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }

      if (action.payload.operation === "add") {
        state.data["comparative_analysis"] &&
          state.data["comparative_analysis"].data.values.push({
            tab_id: action.payload.tabId,
            label: action.payload.label,
          });
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }

      if (action.payload.operation === "delete") {
        state.data["comparative_analysis"].data.values = state.data[
          "comparative_analysis"
        ].data.values.filter((v) => {
          return v.tab_id !== action.payload.tabId;
        });
        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }

      if (action.payload.operation === "update") {
        state.data["comparative_analysis"].data.values = state.data[
          "comparative_analysis"
        ].data.values.map((item) => {
          if (item.tab_id === action.payload.tabId) {
            return { ...item, label: action.payload.label };
          }
          return item;
        });

        return {
          ...state,
          data: {
            ...state.data,
          },
        };
      }

      return state;

    default:
      return state;
  }
}
